<template>
  <section v-if="comments && comments.length > 0" class="ba-mb-4">
    <header class="ba-flex ba-items-center ba-mb-2 ba-font-bold ba-text-primary">
      <h5 class="ba-mr-2">Комментарии</h5>
      <span>{{ commentsCount }}</span>
    </header>
    <ul class="ba-mb-4">
      <li
        v-for="(comment, index) in comments"
        :key="index"
        class="ba-flex ba-mb-2 last:ba-mb-0"
      >
        <figure class="ba-flex-shrink-0 ba-w-3 ba-mr-3">
          <vis-icon-more class="ba-w-full ba-text-text-blue-grey" />
        </figure>
        <div class="ba-flex-1 ba-p-4 ba-bg-background-blocks ba-rounded">
          <vis-approval-queue-user
            :user="comment.user"
            :date="comment.date"
            :time="comment.time"
            class="ba-mb-2 ba-font-semibold"
          />
          <blockquote>
            {{ comment.quote }}
          </blockquote>
        </div>
      </li>
    </ul>
    <footer class="ba-flex ba-justify-center">
      <button
        type="button"
        class="ba-text-accent hover:ba-underline"
      >
        <span>Смотреть еще</span>
        <span class="ba-px-1">3</span>
        <span>комментария</span>
      </button>
    </footer>
  </section>
</template>

<script>
import visApprovalQueueUser from "./vis-approval-queue-user";

export default {
  name: "vis-approval-queue-task-comments",
  components: {
    visApprovalQueueUser
  },
  props: {
    comments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    commentsCount() {
      return this.comments.length
    }
  }
}
</script>
